module.exports = __webpack_public_path__ + "img/loading.2abbc077.gif";